import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  rangePicker: {
    backgroundColor: token.colorBgContainer,
    minWidth: '260px'
  }
}))
